import * as THREE from 'three';
import { GAME_CONFIG } from '../game/config';

export class HeldBall {
  readonly group = new THREE.Group();

  private readonly ballGeometry = new THREE.SphereGeometry(GAME_CONFIG.ballRadius, 24, 16);
  private readonly ballMaterial = new THREE.MeshPhysicalMaterial({
    color: '#fff9e8',
    roughness: 0.42,
    clearcoat: 0.35,
    clearcoatRoughness: 0.38,
  });
  private readonly seamGeometry = new THREE.TorusGeometry(
    GAME_CONFIG.ballRadius * 0.995,
    GAME_CONFIG.ballRadius * 0.042,
    6,
    32,
  );
  private readonly seamMaterial = new THREE.MeshBasicMaterial({ color: '#ef405b' });
  private readonly shadowGeometry = new THREE.CircleGeometry(0.22, 24);
  private readonly shadowMaterial = new THREE.MeshBasicMaterial({
    color: '#07111c',
    transparent: true,
    opacity: 0.28,
    depthWrite: false,
  });
  private readonly ball = new THREE.Mesh(this.ballGeometry, this.ballMaterial);
  private readonly seamA = new THREE.Mesh(this.seamGeometry, this.seamMaterial);
  private readonly seamB = new THREE.Mesh(this.seamGeometry, this.seamMaterial);
  private readonly shadow = new THREE.Mesh(this.shadowGeometry, this.shadowMaterial);
  private elapsed = 0;

  constructor() {
    this.ball.castShadow = true;
    this.ball.receiveShadow = true;
    this.group.add(this.ball);

    this.seamA.rotation.x = Math.PI / 2;
    this.seamB.rotation.y = Math.PI / 2;
    this.ball.add(this.seamA, this.seamB);

    this.shadow.rotation.x = -Math.PI / 2;
    this.shadow.position.y = -0.36;
    this.group.add(this.shadow);
    this.group.position.set(
      GAME_CONFIG.releasePosition.x,
      GAME_CONFIG.releasePosition.y,
      GAME_CONFIG.releasePosition.z,
    );
  }

  update(delta: number, power: number, charging: boolean): void {
    this.elapsed += delta;
    const chargePull = charging ? power * 0.32 : 0;
    this.group.position.y = GAME_CONFIG.releasePosition.y - chargePull * 0.2 + Math.sin(this.elapsed * 2.4) * 0.025;
    this.group.position.z = GAME_CONFIG.releasePosition.z + chargePull;
    const scale = 1 + (charging ? Math.sin(this.elapsed * 13) * power * 0.035 : 0);
    this.ball.scale.setScalar(scale);
    this.ball.rotation.y += delta * (0.7 + power * 5.2);
    this.ball.rotation.x += delta * 0.35;
    this.shadowMaterial.opacity = 0.22 + power * 0.12;
  }

  dispose(): void {
    this.ballGeometry.dispose();
    this.ballMaterial.dispose();
    this.seamGeometry.dispose();
    this.seamMaterial.dispose();
    this.shadowGeometry.dispose();
    this.shadowMaterial.dispose();
  }
}
